export enum DASHBOARD_DENSITY {
  COMPACT = 'compact',
  NORMAL = 'normal',
}
